import React, { Fragment, useEffect, useState } from "react";

import CircularProgressComponent from "components/circularProgress/CircularProgress.component";
import {
  Card,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
  IconButton,
  Tooltip
} from "@mui/material";
import PopoverComponent from "components/popover/Popover.component";
import { useTranslation } from "react-i18next";
import IncomeMinMaxCard from "../income/IncomeMinMaxCard.component";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const MinMaxMeanCards = ({
  colorFrom,
  colorTo,
  min,
  max,
  mean,
  symbol,
  title,
  sm = 12,
  info
}) => {
  const { t } = useTranslation()
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down("md"));
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (mean !== null && max !== null && min !== null) {
      setLoading(false)
    }
  }, [min, max, mean])


  return loading ? <IncomeMinMaxCard /> : (
    <Fragment>
      {(min !== null || max !== null || mean !== null) && (
        <Card
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: matchesSM ? "100%" : 90,
            height: '100%',
           
          }}
          id={title}
        >
          <Grid container pb={1} pt={1}>
            {info &&
              <Grid item xs={12} display="flex" justifyContent="end">
                <PopoverComponent info={info} />
              </Grid>}


            <Grid
              item
              xs={12}
              container
              spacing={2}
            
            >
              {title ? (
                <Grid item xs={12} display='flex' justifyContent='space-between'>
                  <Typography variant="h6" sx={{ color: colorTo, pl: 1 }}>
                    {title}
                  </Typography>

                  <Tooltip
                    title={t('Data relating to the average performance of the period')}
                  >
                    <IconButton sx={{ padding: 0 }}>
                      <InfoOutlinedIcon
                        style={{
                          width: 15,
                          height: 15,
                          color: theme.palette.grey[700],
                          marginRight: 5,
                       

                        }}
                      />
                    </IconButton>
                  </Tooltip>

                </Grid>

              )
                : <Grid
                  item
                  xs={12}
                  display='flex'
                  justifyContent='end'
                  mr={1}
                >
                  <Tooltip
                    title={t('Data relating to the average performance of the period')}
                  >
                    <IconButton sx={{ padding: 0 }}>
                      <InfoOutlinedIcon
                        style={{
                          width: 15,
                          height: 15,
                          color: theme.palette.grey[700],

                        }}
                      />
                    </IconButton>
                  </Tooltip>
                </Grid>}
              {(min || min === 0) && (
                <Grid
                  item
                  xs={4}
                  sm={sm}
                  md={12}
                  lg={12}
                  justifyContent="center"
                  display={"flex"}
                  alignItems="center"
                >
                  <CircularProgressComponent
                    value={(min * 100) / max}
                    labelValue={`${min}${symbol ? symbol : ""}`}
                    label={t('Minimal')}
                    max={max}
                    colorFrom={colorFrom}
                    colorTo={colorTo}
                  />
                </Grid>
              )}

              {(mean || mean === 0) && (
                <Grid
                  item
                  xs={4}
                  sm={sm}
                  md={12}
                  lg={12}
                  justifyContent="center"
                  display={"flex"}
                >
                  <CircularProgressComponent
                    value={(mean * 100) / max}
                    labelValue={`${mean}${symbol ? symbol : ""}`}
                    label={t('Average')}
                    max={max}
                    colorFrom={colorFrom}
                    colorTo={colorTo}
                  />
                </Grid>
              )}

              {(max || max === 0) && (
                <Grid
                  item
                  xs={4}
                  sm={sm}
                  md={12}
                  lg={12}
                  justifyContent="center"
                  display={"flex"}
                >
                  <CircularProgressComponent
                    labelValue={`${max}${symbol ? symbol : ""}`}
                    value={(max * 100) / max}
                    label={t('Maxim')}
                    max={max}
                    colorFrom={colorFrom}
                    colorTo={colorTo}
                    symbol={symbol}
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
        </Card>
      )}
    </Fragment>
  );
};

export default MinMaxMeanCards;
